import { normalizeSpaceCharacter } from './normalizeSpaceCharacter';

export { createStringParser } from './stringParser';
export type { StringParser, ParsedSegment } from './types';

export const normalizers = [normalizeSpaceCharacter];
